<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-modal title="影响用户列表"
           :visible="showTubeView"
           width="80%"
           destroyOnClose
           @ok="closeTubeView"
           @cancel="closeTubeView"
           style="position: absolute; left: 18rem; z-index: 999; top: 3rem">
    <a-table rowKey="id"
             :data-source="dataList"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <a-tag color="blue"
             slot="waterBigStatus"
             slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime"
            slot-scope="text">{{ moment(text).format("YYYY-MM-DD") }}</span>
    </a-table>
  </a-modal>
</template>
<script>
import moment from 'moment'
export default {
  data () {
    return {
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName'
        },
        {
          title: '物探点号',
          dataIndex: 'geophysicalPointNumber'
        },
        {
          title: '编号',
          dataIndex: 'appearanceNo'
        },
        {
          title: '状态',
          dataIndex: 'waterStatus'
        },
        {
          title: '用户编码',
          dataIndex: 'userNo'
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName'
        },
        {
          title: '用户地址',
          dataIndex: 'address'
        },
        {
          title: '电话号码',
          dataIndex: 'telephone'
        },
        {
          title: '安装时间',
          dataIndex: 'installDate',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '口径',
          dataIndex: 'model'
        },
        {
          title: '表型号',
          dataIndex: 'meterModel'
        },
        {
          title: '水价',
          dataIndex: 'waterPrice'
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          scopedSlots: { customRender: 'waterBigStatus' }
        }
      ],
      queryUrl: '/pipe-network/user_water_meters/page',
      dataList: [],
      dataListLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },

      showTubeView: false,
      params: {}
    }
  },
  methods: {
    moment,
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataList()
    },
    edit (params) {
      this.showTubeView = true
      if (params) {
        this.params = params
        this.getDataList()
      }
    },
    // 跳转到对应阀门
    jumpFather (record) {
      this.closeTubeView()
      this.$emit('jumpFather', record)
    },
    // 获取数据
    getDataList () {
      this.dataListLoading = true
      const params = this.params
      params.page = this.pagination.current
      params.limit = this.pagination.pageSize
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView () {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
